import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import { getVisitActivityTasks } from "../../../../services/crm/salesJourney";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { Badge } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function SlcTaskDetail({ visitActivityID = 0, onCloseDialog }) {
  const { reload } = useGlobalData();
  const [tasksData, setTasksData] = useState([]);

  useEffect(() => {
    getVisitActivityTasksData(visitActivityID);
  }, [visitActivityID, reload]);

  const slcTaskDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <CustomDataTable
            data={tasksData}
            dataDetailColumns={slcTaskDetailColumn}
            onRefreshData={() => {
              getVisitActivityTasksData(visitActivityID);
            }}
            columns={[
              {
                header: "Title",
                field: "title",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.title} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Assigned To",
                field: "userName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.userName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Deadline Date",
                field: "deadlineDate",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.deadlineDate}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Status",
                field: "statusID",
                body: (rowData) => (
                  <React.Fragment>
                    <Badge
                      variant={
                        rowData.statusID === 9999 ? "success" : "warning"
                      }
                    >
                      {rowData.statusID === 9999
                        ? "Completed"
                        : rowData.statusName}
                    </Badge>
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
          </DialogActions>
        </div>
      </div>
    </React.Fragment>
  );

  async function getVisitActivityTasksData(visitActivityID) {
    const response = await getVisitActivityTasks(visitActivityID);
    const { data } = response.data;
    setTasksData(data.tasks);
  }
}

export default SlcTaskDetail;
